module.exports = __webpack_public_path__ + "img/bars-solid.22d9a319.svg";